import React, { useRef, useState } from "react";
import {
    I2cInput,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox, I2cRadioGroup, I2cRadioButton, I2cRadio, I2cAlert, I2cIcon
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { features, paymentMethod } from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
const BankaccountsBillpaymentsWallet = ({ control, handleValueChanges, methods, errors, appSelectionForProgram }) => {
    const checkboxRef = useRef(null);
    const handleCheckboxChange = (event, fieldName) => {
        const SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues(fieldName) ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        methods.setValue(fieldName, updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    return (
        <>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                My Bank Account
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_bank_accounts_feature_app_enable"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please confirm if you would like to enable it on the application."
                                    {...field}
                                    name="card_management_feature_bank_accounts_feature_app_enable"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_management_feature_bank_accounts_feature_app_enable_custom","")
                                            methods.setValue("card_management_feature_bank_accounts_feature_required_for",[])
                                            methods.setValue("card_management_feature_bank_accounts_primary_methods_for_account_setup","")
                                            methods.setValue("card_management_feature_bank_accounts_fallback_micropayment_method","")
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_bank_accounts_feature_app_enable") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_bank_accounts_feature_app_enable &&
                                    methods.formState.touchedFields.card_management_feature_bank_accounts_feature_app_enable
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_bank_accounts_feature_app_enable?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_management_feature_bank_accounts_feature_app_enable") === "Yes" && (
                        <>
                            <div i2c-grid="6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_bank_accounts_feature_app_enable_custom"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                label="Enter Custom Name"
                                                placeholder="Leave blank for default name"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"card_management_feature_bank_accounts_feature_app_enable_custom"}

                                            >
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    This feature is required for:
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_bank_accounts_feature_required_for"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="6@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_bank_accounts_feature_required_for")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_bank_accounts_feature_required_for");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_bank_accounts_feature_required_for"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_bank_accounts_feature_required_for")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_bank_accounts_feature_required_for &&
                                                            methods.formState.touchedFields.card_management_feature_bank_accounts_feature_required_for
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_bank_accounts_feature_required_for?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    What is the primary method to set up new bank accounts for cardholders?
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_bank_accounts_primary_methods_for_account_setup"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cRadioGroup
                                                onI2cChange={(e) => {
                                                    methods.setValue("card_management_feature_bank_accounts_primary_methods_for_account_setup", e.target.value);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                            >
                                                <div i2c-grid="grid gap-sm">
                                                    {["Micropayments", "Finicity", "Plaid"].map((cpi, index) => (
                                                        <I2cListItem
                                                            key={index}
                                                            i2c-grid="4@md"
                                                            variant="receipt"
                                                            label={cpi}
                                                            sublabel=""
                                                            value=""
                                                            checked={methods.watch("card_management_feature_bank_accounts_primary_methods_for_account_setup") === cpi}
                                                            type="checkbox"
                                                        >
                                                            <I2cRadio
                                                                slot="prefix"
                                                                name="credit_programType"
                                                                value={cpi}
                                                                filled
                                                                label=""
                                                                checked={
                                                                    methods.watch("card_management_feature_bank_accounts_primary_methods_for_account_setup") === cpi
                                                                }
                                                            />
                                                        </I2cListItem>
                                                    ))}
                                                </div>
                                            </I2cRadioGroup>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="8@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_bank_accounts_fallback_micropayment_method"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cRadioGroup
                                                label="Do you want to enable the micropayment method as a fallback for Finicity and Plaid 
                                    if a cardholder does not have an account on these services?"
                                                {...field}
                                                name="card_management_feature_bank_accounts_fallback_micropayment_method"
                                                onI2cChange={(e) => {
                                                    field.onChange(e);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                            >
                                                {["Yes", "No"].map((bc, index) => (
                                                    <I2cRadioButton
                                                        key={index}
                                                        checked={
                                                            methods.watch("card_management_feature_bank_accounts_fallback_micropayment_method") === bc
                                                        }
                                                        value={bc}
                                                    >
                                                        {bc}
                                                    </I2cRadioButton>
                                                ))}
                                            </I2cRadioGroup>
                                        )}
                                    />
                                    <ErrorMessage
                                        show={
                                            errors.card_management_feature_bank_accounts_fallback_micropayment_method &&
                                                methods.formState.touchedFields.card_management_feature_bank_accounts_fallback_micropayment_method
                                                ? true
                                                : false
                                        }
                                        message={errors.card_management_feature_bank_accounts_fallback_micropayment_method?.message ?? "Invalid input"}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Bill Payment
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <I2cAlert
                        open
                        type="plain"
                        variant="neutral"
                        headerArt="cs-linear-info"
                        layout="layoutAsideLeft" >
                        <span slot="label">This feature is supported in the US region only.</span>
                    </I2cAlert>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_bill_payments_feature_app_enable"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please confirm if you would like to enable this feature on the application."
                                    {...field}
                                    name="card_management_feature_bill_payments_feature_app_enable"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_management_feature_bill_payments_feature_required_for",[])
                                            methods.setValue("card_management_feature_bill_payments_feature_app_enable_custom","") 
                                        }   
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_bill_payments_feature_app_enable") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_bill_payments_feature_app_enable &&
                                    methods.formState.touchedFields.card_management_feature_bill_payments_feature_app_enable
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_bill_payments_feature_app_enable?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_management_feature_bill_payments_feature_app_enable") === "Yes" && (
                        <>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    This feature is required for:
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_bill_payments_feature_required_for"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="6@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_bill_payments_feature_required_for")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_bill_payments_feature_required_for");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_bill_payments_feature_required_for"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_bill_payments_feature_required_for")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_bill_payments_feature_required_for &&
                                                            methods.formState.touchedFields.card_management_feature_bill_payments_feature_required_for
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_bill_payments_feature_required_for?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_bill_payments_feature_app_enable_custom"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                label="Enter Custom Name"
                                                placeholder="Leave blank for default name"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"card_management_feature_bill_payments_feature_app_enable_custom"}

                                            >
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Wallet (In-App) Provisioning
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <I2cAlert
                        open
                        type="plain"
                        variant="neutral"
                        headerArt="cs-linear-info"
                        layout="layoutAsideLeft" >
                        <span slot="label">Applicable for mobile apps only</span>
                    </I2cAlert>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_wallet_provision_feature_app_enable"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Do you want to enable this feature on your card?"
                                    {...field}
                                    name="card_management_feature_wallet_provision_feature_app_enable"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_management_feature_wallet_provision_digital_wallet_types",[])
                                            methods.setValue("card_management_feature_wallet_provision_payment_networks",[])
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_wallet_provision_feature_app_enable") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_wallet_provision_feature_app_enable &&
                                    methods.formState.touchedFields.card_management_feature_wallet_provision_feature_app_enable
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_wallet_provision_feature_app_enable?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_management_feature_wallet_provision_feature_app_enable") === "Yes" && (
                        <>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    Select the supported Digital Wallet types
                                </div>
                                <Controller
                                    name="card_management_feature_wallet_provision_digital_wallet_types"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cCheckboxGroup    {...field}
                                            className="centeredCheckbox checkbox-margin">
                                            <div i2c-grid="grid gap-sm">
                                                {features.map((card, index) => (
                                                    <I2cListItem
                                                        key={index}
                                                        i2c-grid="4@md"
                                                        style={{ display: "flex", alignItems: "center" }}
                                                        variant="receipt"
                                                        label={card.label}
                                                        sublabel=""
                                                        value=""
                                                        type="checkbox"
                                                        checked={
                                                            methods
                                                                .watch("card_management_feature_wallet_provision_digital_wallet_types")
                                                                ?.includes(card.value) ?? false
                                                        }
                                                        onI2cCheckboxClicked={(e) => {
                                                            handleCheckboxChange(card.value, "card_management_feature_wallet_provision_digital_wallet_types");
                                                            methods.trigger();
                                                            handleValueChanges();
                                                        }}
                                                        size="sm"
                                                    >
                                                        <I2cIcon
                                                            slot="prefix"
                                                            src={card.icon}
                                                            style={{ fontSize: "var(--i2c-spacing-10-5)" }}
                                                            label="icon"
                                                        ></I2cIcon>
                                                        <I2cCheckbox
                                                            name="card_management_feature_wallet_provision_digital_wallet_types"
                                                            slot="checkbox"
                                                            value={card.value}
                                                            label=""
                                                            filled
                                                            checked={
                                                                methods
                                                                    .watch("card_management_feature_wallet_provision_digital_wallet_types")
                                                                    ?.includes(card.value) ?? false
                                                            }

                                                            className="custom-checkbox-auto-margin"
                                                        ></I2cCheckbox>
                                                    </I2cListItem>
                                                ))}
                                            </div>
                                        </I2cCheckboxGroup>
                                    )} />
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    Select payment network
                                </div>
                                <Controller
                                    name="card_management_feature_wallet_provision_payment_networks"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cCheckboxGroup    {...field}
                                            className="centeredCheckbox checkbox-margin">
                                            <div i2c-grid="grid gap-sm">
                                                {paymentMethod.map((card, index) => (
                                                    <I2cListItem
                                                        key={index}
                                                        i2c-grid="4@md"
                                                        style={{ display: "flex", alignItems: "center" }}
                                                        variant="receipt"
                                                        label={card.label}
                                                        sublabel=""
                                                        value=""
                                                        type="checkbox"
                                                        checked={
                                                            methods
                                                                .watch("card_management_feature_wallet_provision_payment_networks")
                                                                ?.includes(card.value) ?? false
                                                        }
                                                        onI2cCheckboxClicked={(e) => {
                                                            handleCheckboxChange(card.value, "card_management_feature_wallet_provision_payment_networks");
                                                            methods.trigger();
                                                            handleValueChanges();
                                                        }}
                                                        size="sm"
                                                    >
                                                        <I2cIcon
                                                            slot="prefix"
                                                            src={card.icon}
                                                            style={{ fontSize: "var(--i2c-spacing-10-5)" }}
                                                            label="icon"
                                                        ></I2cIcon>
                                                        <I2cCheckbox
                                                            name="card_management_feature_wallet_provision_payment_networks"
                                                            slot="checkbox"
                                                            value={card.value}
                                                            label=""
                                                            filled
                                                            checked={
                                                                methods
                                                                    .watch("card_management_feature_wallet_provision_payment_networks")
                                                                    ?.includes(card.value) ?? false
                                                            }

                                                            className="custom-checkbox-auto-margin"
                                                        ></I2cCheckbox>
                                                    </I2cListItem>
                                                ))}
                                            </div>
                                        </I2cCheckboxGroup>
                                    )} />
                            </div>
                        </>
                    )
                }
            </div>
        </>
    );
};

export default BankaccountsBillpaymentsWallet;
